import React from "react";
import ManIcon from "@mui/icons-material/Man";
import WomanIcon from "@mui/icons-material/Woman";
import GlobalBasicBarChart from "../../charts/barChart/GlobalBasicBarChart";
import CircularProgress from "@mui/material/CircularProgress";

const GlobalObservadoresMiniCard = ({
  title,
  suffix,
  data,
  globalCardsLoader,
  Icon,
  helperText,
}) => {
  return (
    <div className="w-full h-full flex flex-col bg-white border-black border-1 rounded-2xl">
      <div className="flex items-center w-full h-1/4 pl-1">
        <div className="w-[35px] h-[24px] object-contain">
          {typeof Icon === "string" ? (
            <img src={Icon} className="w-full h-full" alt="svg" />
          ) : (
            <Icon sx={{ width: "100%" }} />
          )}
        </div>
        <h3 className="sm:text-sm lg:text-xl xl:text-2xl font-medium text-left font-Roboto">{title}</h3>
      </div>
      <div className="h-1/4 flex flex-col">
        <p className="font-bold sm:text-3xl lg:text-4xl xl:text-5xl leading-none">
          {Number(data.total).toLocaleString() + suffix}
        </p>
        {helperText ? (
            <div className="pt-2">
              <p className="sm:text-xs xl:text-sm text-center text-gray-400">{helperText}</p>
            </div>
          ) : null}
      </div>
      {globalCardsLoader ? (
        <div className="flex items-center justify-center gap-4">
          <CircularProgress color="secondary"></CircularProgress>
        </div>
      ) : (
        <div className="flex flex-col">
          <div className="flex flex-row w-full justify-between pr-2">
            <div className="flex flex-col justify-center items-center w-1/5 h-full">
              <ManIcon sx={{ width: "35px", height: "35px" }} />
              <WomanIcon sx={{ width: "35px", height: "35px" }} />
            </div>
            <div className="w-3/5 flex -ml-16">
              <GlobalBasicBarChart seriesData={data} />
            </div>
            <div className="flex sm:text-base lg:text-lg xl:text-2xl flex-col items-center justify-center font-bold font-Roboto w-1/5 h-full whitespace-nowrap text-lg gap-1">
              <p>{Number(data.man.toFixed(1)).toLocaleString() + suffix}</p>
              <p>{Number(data.woman.toFixed(1)).toLocaleString() + suffix}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalObservadoresMiniCard;
